import PropTypes from 'prop-types';
import { TooltipPropTypes } from '../../Tooltip';
const propTypes = {
    /** applied as data-hook HTML attribute that can be used to create driver in testing */
    // @ts-expect-error
    dataHook: TooltipPropTypes.dataHook,
    /** A css class to be applied to the component's root element */
    className: TooltipPropTypes.className,
    /** tooltip trigger element. Can be either string or renderable node */
    children: PropTypes.node.isRequired,
    /** tooltip content. Can be either string or renderable node */
    content: TooltipPropTypes.content,
    /** align tooltip content */
    textAlign: TooltipPropTypes.textAlign,
    /** time in milliseconds to wait before showing the tooltip */
    enterDelay: TooltipPropTypes.enterDelay,
    /**  time in milliseconds to wait before hiding the  Defaults to 0. */
    exitDelay: TooltipPropTypes.exitDelay,
    /** moves tooltip content relative to the parent by x or y */
    moveBy: TooltipPropTypes.moveBy,
    /** Moves arrow by amount */
    moveArrowTo: TooltipPropTypes.moveArrowTo,
    /** tooltips content calculation relation to a dom element. Can be either:
     *  `'window', 'scrollParent', 'viewport', 'parent'`, `element` or
     * `function` based predicate i.e. (elm) =>
     *  elm.getAttribute('data-hook') === 'value'
     */
    appendTo: TooltipPropTypes.appendTo,
    /** whether to enable the flip behaviour. This behaviour is used to flip the Tooltips placement when it starts to overlap the target element. */
    flip: TooltipPropTypes.flip,
    /** whether to enable the fixed behaviour. This behaviour is used to keep the Tooltip at it's original placement even when it's being positioned outside the boundary. */
    fixed: TooltipPropTypes.fixed,
    /** tooltip content container width in pixels */
    maxWidth: TooltipPropTypes.maxWidth,
    /** callback on tooltips content show event */
    onShow: TooltipPropTypes.onShow,
    /** callback on tooltips content hide event */
    onHide: TooltipPropTypes.onHide,
    /** tooltip content placement in relation to target element */
    placement: TooltipPropTypes.placement,
    /** disables tooltip element trigger behaviour. If not specified, `disabled` prop of the `children` element will be used. */
    disabled: TooltipPropTypes.disabled,
    /** sets size of the tooltip */
    size: TooltipPropTypes.size,
    /** establishes a relationship between tooltip element and tooltip content for a11y purposes */
    'aria-describedby': TooltipPropTypes['aria-describedby'],
    /** tooltips content zindex */
    zIndex: TooltipPropTypes.zIndex,
    /** stretch root element to the width of its container. */
    fluid: TooltipPropTypes.fluid,
};
/**
 * TODO: JB: not all props from TooltipCommonProps are in TooltipCommonPropTypes
 **/
export const TooltipCommonPropTypes = {
    appendTo: propTypes.appendTo,
    disabled: propTypes.disabled,
    enterDelay: propTypes.enterDelay,
    exitDelay: propTypes.exitDelay,
    fixed: propTypes.fixed,
    flip: propTypes.flip,
    maxWidth: propTypes.maxWidth,
    moveArrowTo: propTypes.moveArrowTo,
    moveBy: propTypes.moveBy,
    onHide: propTypes.onHide,
    onShow: propTypes.onShow,
    placement: propTypes.placement,
    textAlign: propTypes.textAlign,
    zIndex: propTypes.zIndex,
    size: propTypes.size,
};
//# sourceMappingURL=TooltipCommon.js.map